import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const NoSearchResult = ({ children, className = void 0 }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(Alert, { className: `${className != null ? className : ""} no-bm` }, children || t("empty.no_data"));
};
export default NoSearchResult;
